import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { POST_LOGOUT_REDIRECT_URI } from 'config/oktaConfig';
import { LoaderOverlay } from 'components';

export default function LogoutPage() {
    const { oktaAuth } = useOktaAuth();
    const navigate = useNavigate();
    
    useEffect(() => {
        const signOut = async () => {
            const isAuth = await oktaAuth.isAuthenticated();
            if (isAuth) {
                try {
                    window.Intercom?.('shutdown');
                } catch { }
                await oktaAuth.signOut({ postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI });
            }
            else {
                navigate('/');
            }
        }

        signOut();
    }, [oktaAuth]);

    return <LoaderOverlay isLoading>Logging out...</LoaderOverlay>;
}